
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { ComponentDocs, Preview } from "@lighting-beetle/lighter-styleguide";
import Icon from "./index";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Icon`}</h1>
    <h2>{`Example`}</h2>
    <Icon name="heart" className="text-color-error mb" mdxType="Icon" />
    <h2>{`Variants`}</h2>
    <h3>{`Basic`}</h3>
    <Preview mdxType="Preview">
  <Icon name="heart" mdxType="Icon" />
    </Preview>
    <h3>{`Sizes`}</h3>
    <Preview mdxType="Preview">
  <Icon name="heart" size="small" mdxType="Icon" />
  <Icon name="heart" size="medium" mdxType="Icon" />
  <Icon name="heart" size="large" mdxType="Icon" />
  <Icon name="heart" size="xlarge" mdxType="Icon" />
    </Preview>
    <h2>{`Colors`}</h2>
    <Preview mdxType="Preview">
  <Icon name="heart" size="large" className="text-color-theme" mdxType="Icon" />
  <Icon name="heart" size="large" className="text-color-grey" mdxType="Icon" />
  <Icon name="heart" size="large" className="text-color-error" mdxType="Icon" />
    </Preview>
    <h2>{`Props`}</h2>
    <ComponentDocs title="<Icon />" component={Icon} mdxType="ComponentDocs" />
    <h2>{`Accessibility`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`alt`}</inlineCode>{` attribute can be used to provide a textual alternative. When the icon is purely presentational (e.g. in a button that provides a meaningful textual label), use an empty string for the `}<inlineCode parentName="p">{`alt`}</inlineCode>{` prop.
\`;`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;